import React from "react";
import { MessageFilled, WechatOutlined } from "@ant-design/icons";
import { Box } from "./../base";
import { useChat } from "./hooks";
import "./styles.css";
import { useAuthorize, useIsAdmin } from "components/CurrentUser/hooks";
import { Resource, Permission } from "components/CurrentUser/constants";
import { useCurrentUser } from "components/CurrentUser/hooks";
import { isMicroApp } from "utils/microApp";

const Chat = () => {
  const { chatWithNewChannel } = useChat();

  const [user] = useCurrentUser({
    revalidateOnMount: !isMicroApp,
    revalidateOnFocus: !isMicroApp,
    revalidateOnReconnect: !isMicroApp,
  });

  const hasChatPermission = useAuthorize([
    [Resource.CHAT_AGENT, Permission.FULL_VIEW],
    [Resource.CHAT_AGENT, Permission.FULL_CREATE],
  ]);

  if (user?.type === "KOL" || hasChatPermission) {
    return (
      <Box
        position="fixed"
        display="flex"
        right={30}
        bottom={0}
        zIndex={99}
        id="tiki-chat"
        flexDirection="row"
        width={80}
        justifyContent="center"
        alignItems="center"
        onClick={chatWithNewChannel}
      >
        <WechatOutlined
          style={{
            fontSize: 30,
            color: "rgb(11, 116, 229)",
          }}
        />
        <div
          style={{
            color: "rgb(11, 116, 229)",
            fontSize: 15,
            marginLeft: 5,
          }}
        >
          Chat
        </div>
      </Box>
    );
  }

  return null;
};

export default Chat;
